<template>
  <div class="card">
    <div class="card-header">
      <h5>Aged Debtors Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Due Date range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <dateTimePicker
                no-label
                label="From Date"
                id="booking_date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="debtorreportFrom.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :max-date="debtorreportTo.date"
              />
              <small class="text-danger" v-if="errors.from_date">{{ errors.from_date }}</small>
            </div>
            <div class="col-md-4">
              <dateTimePicker
                no-label
                label="To Date"
                id="booking_date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="debtorreportTo.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :min-date="debtorreportFrom.date"
              />
              <small class="text-danger" v-if="errors.to_date">{{ errors.to_date }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button
        type="submit"
        class="button"
        v-on:click.prevent="getDebtorReport"
      >
        Generate report
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AgedDebtorField",
  data() {
    return {
      debtorreportFrom: {},
      debtorreportTo: {},
      errors: {
        from_date:null,
        to_date:null
      },
    };
  },
  methods: {
    getDebtorReport() {
      this.validateFields()
          .then((response) => {
            if (response) {
              this.$store.dispatch("setLoadStatus");
              const request = {
                from_date: this.debtorreportFrom.date,
                to_date: this.debtorreportTo.date
              }
              fetch(this.$api + 'reports/debtor-booking', {
                method: 'POST',
                body: JSON.stringify(request),
                headers:{
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': localStorage.getItem('token')
                }
              })
              .then((res) => {
                if(res.status === 200) {
                  this.$store.dispatch('setLoadStatus')
                  res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', 'Debtor-Report.xlsx')
                    document.body.appendChild(link)
                    link.click();
                  })
                } else {
                  this.$store.dispatch('setLoadStatus')
                  Promise.race([res.json()])
                  .then(response => {
                    if(response.message) {
                      this.$notify({
                        type: 'error',
                        title: response.message
                      });
                    } else {
                      this.$notify({
                        type: 'error',
                        title: response.error
                      });
                    }
                  })
                }
              })
              
            }
          })
          .catch(error => console.log(error))
    },
    validateFields(){

      let This = this

      return new Promise((resolve, reject) => {

        let errorCount = 0;
        This.errors = {
          from_date:null,
          to_date:null
        }
        // Booking Dates validation
        if(!This.debtorreportFrom.date){
          This.errors.from_date = "Please select a valid due from date"
          errorCount +=1
        }else if(This.debtorreportFrom.date && !This.debtorreportTo.date){
          This.errors.to_date = "Please select a valid due to date"
          errorCount +=1
        }else{
          This.errors.to_date = null
          This.errors.from_date = null
        }

        if(errorCount == 0 ){
          resolve(true)
        }else{
          reject(true)
        }

      })
    }
  }
};
</script>
